<template>

  <div class="myCenter" :key="isArabic">

        <div class="mt-10 w-4/5 h-2/3 lg:w-1/2 lg:h-1/2 swiper-container" >

            <div v-swiper:mySwiper="swiperOptions" @touchstart="stopSliding()">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide" >
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-dance.jpg"/> 
                        </div>

                        <div class="-mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink z-30 w-5/6 opacity-100 shadow-xl rounded-lg">{{$t('ads.imgAd1')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-class.jpg"/> 
                        </div>

                        <div class="-mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink z-30 w-5/6 opacity-100 shadow-xl rounded-lg">{{$t('ads.imgAd2')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-ma.jpg"/> 
                        </div>

                        <div class="-mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink w-5/6 opacity-100 shadow-xl rounded-lg">{{$t('ads.imgAd3')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-gym.jpg"/> 
                        </div>

                        <div class="-mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink text- z-30 w-5/6 opacity-100 shadow-xl rounded-lg">{{$t('ads.imgAd4')}}</label>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        
                        <div>

                            <img class="object-contain shadow-md opacity-100" src="@/assets/images/swiper-workout.jpg"/> 
                        </div>

                        <div class="-mt-12 flex justify-center h-8">

                            <label class="bg-white h-8 my-image-text-pink text- z-30 w-5/6 opacity-100 shadow-xl rounded-lg">{{$t('ads.imgAd5')}}</label>
                        </div>  

                        <div class="bg-white mt-12"></div>

                    </div>
                </div>

                <div>

                    
                </div>
                <div class="swiper-pagination mt-64"></div>
         
               <!-- <div class="swiper-pagination swiper-pagination-bullets mt-10"></div> -->

            </div>
        </div>
  </div>
</template>

<script>

// import { directive } from 'vue-awesome-swiper'

export default {

    mounted(){

        // this.mySwiper.slideTo(0, 1000, false)

        this.oneAutoSlide(0)
        // this.swiper();
    },

    // directives: {
       
    //    swiper: directive
    // },

    methods:{

        oneAutoSlide(i){
            
            const theSwiper = this.mySwiper;
            let position = i + 1;

            if(position == 5){

                position = 0;
                
                // this.stopSlide = true;
            }

            // console.log(`position: ${position}`)

            const oneAutoSlideMethod = this.oneAutoSlide;

            if(this.stopSlide == false){

                const stopSlide = this.stopSlide;

                setTimeout(function(){

                    if(stopSlide ==  false){

                        theSwiper.slideTo(i, 1000, false)
                    }
                    
                    oneAutoSlideMethod(position);
                }, 2000);
            }
        },

        stopSliding(){

            this.stopSlide = true;
            // console.log('clicked');
        },

        swiper() {
            
            // return this.$refs.mySwiper.$swiper
        },
    },

    data:function(){

        return{

            stopSlide: false,

            isArabic: this.$i18n.locale == 'ar',

            // swiperOptions: {
            //     // loop: true,

            //     // fadeEffect: { crossFade: true },
			// 	effect: "fade", 
            //     //  effect: 'cube',

            //     //  effect: 'coverflow',
            //     //     coverflowEffect: {
            //     //         rotate: 50,
            //     //     },
            //     pagination: {
            //         el: '.swiper-pagination'
            //     },
            //     // Some Swiper option/callback...

            // banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],

            // }    
            
            swiperOptions: {
            
            loop: true,
            // effect: 'fade',
            // effect: 'cube',

            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true
            }
        }
        }
    },

    watch: {
        
        '$i18n.locale'(newValue) {

                this.isArabic =  this.$i18n.locale == 'ar';          
            }
        },

}
</script>


<style lang="scss" scoped>
  .example {
    height: auto;
    .swiper {
      height: 300px;
      width: 100%;
      .swiper-slide {
        text-align: center;
        font-size: 38px;
        font-weight: 700;
        background-color: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .swiper-pagination {
        > .swiper-pagination-bullet {
          background-color: red;
        }
      }
    }
  }